import { API_BASE } from './config';
import { getAdminToken } from './auth-tokens';

const ID = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
const privateResumePath = new RegExp(`^/api/files/private-resumes/${ID}/${ID}/${ID}/[^/]+$`, 'i');
const approvalCvPath = new RegExp(`^/api/offers/workflow/${ID}/cv$`, 'i');

/** Never attach recruiter credentials to candidate-supplied or external URLs. */
export function isPrivateResumeUrl(value: string | null | undefined): value is string {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.origin === new URL(API_BASE).origin && !url.username && !url.password
      && (privateResumePath.test(url.pathname) || approvalCvPath.test(url.pathname))
      && !url.search && !url.hash;
  } catch { return false; }
}

export async function fetchPrivateResume(value: string, preview: boolean, signal: AbortSignal): Promise<Blob> {
  if (!isPrivateResumeUrl(value)) throw new Error('Invalid resume link');
  const token = getAdminToken();
  if (!token) throw new Error('Sign in to view this resume.');
  const url = new URL(value);
  if (preview) url.searchParams.set('preview', '1');
  const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` }, credentials: 'omit',
    redirect: 'error', cache: 'no-store', signal });
  if (!response.ok) throw new Error(response.status === 401 ? 'Sign in to view this resume.' : 'This resume is unavailable.');
  const blob = await response.blob();
  if (blob.size > 20 * 1024 * 1024 || blob.size === 0 || !['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/msword'].includes(blob.type)) {
    throw new Error('This resume is unavailable.');
  }
  return blob;
}
